import actions from "./actions";

const initialState = {
  operator: null,
  authChecking: true,
  authSubmitting: false,
  authError: null,
  dashboard: null,
  dashboardLoading: false,
  dashboardError: null,
  users: [],
  invitations: [],
  usersPagination: { page: 1, per_page: 25, total: 0, total_pages: 0 },
  usersLoading: false,
  usersError: null,
  userDetail: null,
  organizations: [],
  organizationsLoading: false,
  organizationsError: null,
  organizationDetail: null,
  organizationDetailLoading: false,
  organizationDetailError: null,
  intelligenceReport: null,
  intelligenceLoading: false,
  intelligenceError: null,
  mutationLoading: false,
  feedback: null,
};

export default function adminReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CHECK_AUTH_REQUEST:
      return { ...state, authChecking: true, authError: null };
    case actions.CHECK_AUTH_SUCCESS:
    case actions.SIGN_IN_SUCCESS:
      return { ...state, operator: action.user, authChecking: false, authSubmitting: false, authError: null };
    case actions.CHECK_AUTH_FAILED:
      return { ...state, operator: null, authChecking: false, authError: action.error || null };
    case actions.SIGN_IN_REQUEST:
      return { ...state, authSubmitting: true, authError: null };
    case actions.SIGN_IN_FAILED:
      return { ...state, operator: null, authSubmitting: false, authError: action.error };
    case actions.SIGN_OUT_SUCCESS:
      return { ...initialState, authChecking: false };
    case actions.FETCH_DASHBOARD_REQUEST:
      return { ...state, dashboardLoading: true, dashboardError: null };
    case actions.FETCH_DASHBOARD_SUCCESS:
      return { ...state, dashboard: action.summary, dashboardLoading: false };
    case actions.FETCH_DASHBOARD_FAILED:
      return { ...state, dashboardLoading: false, dashboardError: action.error };
    case actions.FETCH_USERS_REQUEST:
      return { ...state, usersLoading: true, usersError: null };
    case actions.FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.data.users,
        invitations: action.data.invitations || [],
        usersPagination: action.data.pagination,
        usersLoading: false,
      };
    case actions.FETCH_USERS_FAILED:
      return { ...state, usersLoading: false, usersError: action.error };
    case actions.FETCH_USER_SUCCESS:
      return { ...state, userDetail: action.detail };
    case actions.FETCH_USER_FAILED:
      return { ...state, usersError: action.error };
    case actions.CLEAR_USER_DETAIL:
      return { ...state, userDetail: null };
    case actions.FETCH_ORGANIZATIONS_REQUEST:
      return { ...state, organizationsLoading: true, organizationsError: null };
    case actions.FETCH_ORGANIZATIONS_SUCCESS:
      return { ...state, organizations: action.data.organizations, organizationsLoading: false };
    case actions.FETCH_ORGANIZATIONS_FAILED:
      return { ...state, organizationsLoading: false, organizationsError: action.error };
    case actions.FETCH_ORGANIZATION_REQUEST:
      return { ...state, organizationDetailLoading: true, organizationDetailError: null };
    case actions.FETCH_ORGANIZATION_SUCCESS:
      return { ...state, organizationDetail: action.detail, organizationDetailLoading: false };
    case actions.FETCH_ORGANIZATION_FAILED:
      return { ...state, organizationDetailLoading: false, organizationDetailError: action.error };
    case actions.FETCH_INTELLIGENCE_COSTS_REQUEST:
      return { ...state, intelligenceLoading: true, intelligenceError: null };
    case actions.FETCH_INTELLIGENCE_COSTS_SUCCESS:
      return { ...state, intelligenceReport: action.report, intelligenceLoading: false };
    case actions.FETCH_INTELLIGENCE_COSTS_FAILED:
      return { ...state, intelligenceLoading: false, intelligenceError: action.error };
    case actions.CREATE_ORGANIZATION_REQUEST:
    case actions.UPDATE_ORGANIZATION_REQUEST:
    case actions.UPDATE_USER_REQUEST:
    case actions.EXTEND_TRIAL_REQUEST:
    case actions.DELETE_USER_REQUEST:
    case actions.INVITE_ORGANIZATION_REQUEST:
    case actions.RESEND_INVITATION_REQUEST:
    case actions.DELETE_MEMBER_REQUEST:
    case actions.ISSUE_INVOICE_REQUEST:
      return { ...state, mutationLoading: true, feedback: null };
    case actions.MUTATION_SUCCESS:
      return { ...state, mutationLoading: false, feedback: action.feedback };
    case actions.MUTATION_FAILED:
      return { ...state, mutationLoading: false, feedback: { type: "error", message: action.error } };
    case actions.CLEAR_FEEDBACK:
      return { ...state, feedback: null };
    default:
      return state;
  }
}
